/* Add class in first tab */
document.querySelector('.product_tabs ul.tabs li') && 
document.querySelector('.product_tabs ul.tabs li').classList.add('current');

if(document.querySelectorAll('[data-tabs="specifications"]').length > 0){
  document.querySelectorAll('.download-button.hide').forEach((ele)=>{
    ele.classList.remove('hide')
  })
}

/* product-promotion-text */
if(document.querySelector('.collection-offer-announcement .collOfferAnno-close')){
  document.querySelector('.collection-offer-announcement .collOfferAnno-close').addEventListener('click',function(e){
    e.target.closest('.collection-offer-announcement').classList.add('hide');
  });
}
/* product-promotion-text */

$(document).on('click', '.product-varient .select-selected', function(event){
  const triggerEle =  $(this).closest('.custom-select');
  triggerEle.addClass('current');
  $('.custom-select.open:not(.current)').removeClass('open');
  triggerEle.toggleClass('open');
  triggerEle.removeClass('current');
});
function waCarryColourToPicker(clicked){
  try {
    if( !clicked || clicked.tagName !== 'INPUT' || /by the foot/i.test(clicked.value) ) return;
    const variantSelects = clicked.closest('variant-selects');
    if( !variantSelects || !variantSelects.currentVariant ) return;
    const colourFieldset = variantSelects.querySelector('fieldset[data-filedset-color="true"]');
    if( !colourFieldset || colourFieldset.contains(clicked) || colourFieldset.querySelector('input[type="radio"]:checked') ) return;
    const colourIndex = parseInt(colourFieldset.dataset.index, 10);
    if( isNaN(colourIndex) ) return;
    const current = variantSelects.currentVariant['option' + (colourIndex + 1)];
    const items = Array.from(colourFieldset.querySelectorAll('.items'));
    const buyable = items.filter((item) => item.dataset.waQuote !== 'true' && item.querySelector('input[type="radio"]'));
    const pick = buyable.find((item) => item.querySelector('input').value === current) || buyable[0];
    if( !pick ) return;
    const radio = pick.querySelector('input[type="radio"]');
    radio.checked = true;
    const box = colourFieldset.querySelector('.select-selected');
    if( box ){
      const label = pick.querySelector('label');
      label && (box.innerHTML = label.innerHTML);
      box.setAttribute('data-not-selected', false);
    }
    colourFieldset.querySelector('.selected-varient') && (colourFieldset.querySelector('.selected-varient').textContent = radio.value);
  } catch(e) { /* never block the click */ }
}

$(document).on('click', '.product-varient input, .product-varient .items[data-value]', function(event){

  const _thisEle = this;
  const _$thisFieldset = $(_thisEle).closest('fieldset');

  // Leaving By the Foot for a spool: on By the Foot the colour lives in the length row, so the main
  // colour picker has nothing ticked. Without a colour the theme cannot find "colour + spool", marks the
  // spool as unavailable and jumps to the next size. Tick the current colour first (this runs before the
  // change event), and never a quote-only one.
  waCarryColourToPicker(_thisEle);
  const _currentIndex = parseInt(_$thisFieldset.attr('data-index'), 10);
  if( !isNaN(_currentIndex) && _currentIndex > 0 ){
    const _$variantSelects = _$thisFieldset.closest('variant-selects');
    let _$missingFieldset = null;
    _$variantSelects.find('fieldset:not(.hidden)').each(function(){
      const _idx = parseInt($(this).attr('data-index'), 10);
      if( !isNaN(_idx) && _idx < _currentIndex && $(this).find('[data-not-selected="true"]:not([data-length-feature])').length > 0 ){
        _$missingFieldset = $(this);
        return false;
      }
    });
    if( _$missingFieldset ){
      const _$candidates = _$missingFieldset.find('.items:not(.hide-sold_out):not(.disabled) input[type="radio"]:not(.disabled), .pricing-option:not(.hide-sold_out) input[type="radio"]:not(.disabled), input[type="radio"]:not(.disabled)');
      // Skip quote-only colours so the automatic pick lands on a colour the shopper can buy.
      const _$buyable = _$candidates.filter(function(){ return $(this).closest('[data-wa-quote="true"]').length === 0; });
      const _$firstInput = (_$buyable.length ? _$buyable : _$candidates).first();
      _$firstInput.length && _$firstInput.trigger('click');
    }
  }
  
  const triggerEle =  $(this).closest('.custom-select').find('.select-selected');
  const has_in_active = $(this).hasClass('inactive-item'), has_length = $(this).closest('.length-active').length > 0;
  let el_label = $(this).find('label').length == 0 ? $(this).parent().find('label'): $(this).find('label');

  if( $(this).attr('data-value') != null ){
    triggerEle.empty().append(el_label.html());    
  }else{
    triggerEle.empty().append($(this).parent().find('label').html());
  }  
  const text_value = $(this).attr('data-value') != null ? $(this).attr('data-value') : $(this).val();
  $(this).closest('fieldset').find('.selected-varient').text(text_value.trim());    

  if( $(this).closest('fieldset').find('.varient-error-message').length == 0 ){
    $(this).closest('.fieldset_qty--wrapper').find('.varient-error-message').addClass('hide');
  }else{
    $(this).closest('fieldset').find('.varient-error-message').addClass('hide');
  }

  if( $(this).closest('variant-selects').length ) {
    triggerEle.attr('data-not-selected', false);
  }
  
  triggerEle.parent().removeClass('open');
  if( !has_in_active ){
    triggerEle.removeClass('not-active');
  }else{
    triggerEle.addClass('not-active');
  }

  if( has_length ){
    const color_ele = $(this).closest('.productinfo-wrapper')[0].querySelector('variant-selects [data-filedset-color="true"]');
    if( color_ele ){
      color_ele.querySelector('.select-selected').dataset.notSelected = 'true';
      color_ele.querySelector('.select-selected').innerHTML = 'Please select';
      color_ele.querySelector('input:checked') && (color_ele.querySelector('input:checked').checked = false);
      color_ele.querySelector('.select-selected').setAttribute('data-length-feature', '');
    }else{
      color_ele.querySelector('.select-selected').removeAttribute('data-length-feature');
    }
  }
});


class productRecommended extends HTMLElement {
	constructor() {
		super();		
		this.querySelector('.reco-add-btn:not([aria-label="quick-view-button"])') && (
      this.querySelector('.reco-add-btn:not([aria-label="quick-view-button"])').addEventListener('click', this.cartRecommendedAdd.bind(this))
    )
	}

	cartRecommendedAdd(event) {
		const clickEle = this.querySelector('.reco-add-btn');		
		const data_obj = {
			id: clickEle.dataset.varaintId,
			properties: {
				_reference_product: clickEle.dataset.refeHandle
			}
		};
		var cart = document.querySelector('cart-items') || document.querySelector('cart-drawer cart-drawer-items');
    var cart_render = document.querySelector('cart-items') || document.querySelector('cart-drawer');
		
    if( cart ){
      data_obj.sections = cart.getSectionsToRender().map((e => e.section));
      data_obj.sections_url = window.location.pathname;
    }

		event.preventDefault();
		console.log('haDrawer', data_obj);

		const o = JSON.stringify(data_obj); 
		fetch(`${ routes.cart_add_url }`, {
			...fetchConfig(),
			body: o
	 })
	 .then((e => e.json()))
	 .then((t => {
			console.log('t', t);
      if (!cart_render) {
        window.location = window.routes.cart_url;        
        return;
      }else{
        cart_render.renderContents(t);
      }			
	 }))
	}
}
customElements.define('product-recommended', productRecommended)


/* Length Function STR */
function productLength(event, ele) {
  const tis = ele, qty_box_ele = tis.closest('.quantity-box');
  const closeNode = qty_box_ele.querySelector('.fieldset_qty--wrapper').cloneNode(true);
  closeNode.querySelectorAll('[data-default-text]').forEach((ele)=>{
    ele.innerHTML = ele.dataset.defaultText;
  });
  //closeNode.querySelector('.select-selected').classList.add('not-active');
  closeNode.querySelector('.varient-error-message').classList.add('hide');
  
  
  if( closeNode.querySelector('.quantity-label')){    
    var text = closeNode.querySelector('.quantity-label').innerText.trim();
    if ( text == "ft" ){
      closeNode.querySelector('input[name="quantity"]').value = closeNode.querySelector('input[name="quantity"]').min
    }else{
      closeNode.querySelector('input[name="quantity"]').value = 1
    }
    closeNode.querySelector('input[name="quantity"]').removeAttribute('name');    
  }
  
  qty_box_ele.insertBefore(closeNode, tis);
  if( qty_box_ele.querySelectorAll('.fieldset_qty--wrapper').length > 9 ){
    tis.remove();    
  }

  if(qty_box_ele.querySelectorAll('.fieldset_qty--wrapper').length > 1){
    qty_box_ele.classList.add('more-than-one');
  }
  updateBtnPrice(ele);
};

function checkForTheVariant(e, item){
  const pro_con_ele = item.closest('.product__info-container'), field_qty_ele = item.closest('.fieldset_qty--wrapper');
  var value_array = [];
  value_array[item.closest('[data-index]').dataset.index] = item.dataset.value;

  pro_con_ele.querySelectorAll('variant-selects fieldset:not(.hidden)').forEach((element)=>{
    if( element.querySelector('input:checked') ){
      value_array[element.dataset.index] = element.querySelector('input:checked').value;
    }
  });  
  
  const selected_variant = pro_con_ele.querySelector('variant-selects').getVariantData().find(
				(variant) =>(value_array).every(
						(value, index) => variant[`option${index + 1}`] === value
        )
  )  
  
  if( selected_variant ){
    const se_variant_info = pro_con_ele.closest('.main-product').querySelector('[json-variant-metafields]');
    field_qty_ele.dataset.variantId = selected_variant.id;        

    let se_variant_meta = {};
    se_variant_info && (      
      se_variant_meta = JSON.parse(se_variant_info.innerHTML)[selected_variant.id]
    )
  
    if(se_variant_meta){
      setEleAttribute(field_qty_ele, 'data-max-qty', se_variant_meta.max_qunatity, se_variant_meta.convert_qunatity);
      setEleAttribute(field_qty_ele, '', se_variant_meta.min_qunatity, se_variant_meta.convert_min_qunatity, true);
      // if( se_variant_meta.max_qunatity != null ){        
      //   field_qty_ele.setAttribute('data-max-qty', se_variant_meta.max_qunatity);
      // }else{
      //   field_qty_ele.removeAttribute('data-max-qty');
      // }
    }

    field_qty_ele.closest('.product__info-container').querySelector('variant-selects') && (
      field_qty_ele.closest('.product__info-container').querySelector('variant-selects').updateMedia(selected_variant)
    );
    
  }else{
    field_qty_ele.removeAttribute('data-variant-id');
    field_qty_ele.removeAttribute('data-max-qty');
  }
}

function setEleAttribute(ele, attr, value, value2, set_min_qty = false){
  if( attr != '' ){
    if( value ){
      ele.setAttribute(attr, value2 ? value2 : value);
    }else{
      ele.removeAttribute(attr, value2 ? value2 : value);
    }
  }
  if( set_min_qty ){
    if( value2 || value ){
      let temp = value2 ? value2 : value;
      ele.querySelector('.quantity__input').dataset.min = temp;
      ele.querySelector('.quantity__input').min = temp;
      ele.querySelector('.quantity__input').value = temp;
      ele.querySelector('quantity-input').maxQty(ele.querySelector('.quantity__input'))
    }    
  }

}

function deleteLengthRow(e, ele){
  const qty_box_ele = ele.closest('.quantity-box');
  if( (qty_box_ele.querySelectorAll('.fieldset_qty--wrapper').length - 1) == 1 ){
    qty_box_ele.classList.remove('more-than-one');
  }
  ele.closest('.fieldset_qty--wrapper').remove();
  if( qty_box_ele && qty_box_ele.querySelector('.fieldset_qty--wrapper') ){
    qty_box_ele.querySelector('.fieldset_qty--wrapper .quantity__input').setAttribute('name','quantity');
  }
  updateBtnPrice(qty_box_ele.closest('.productinfo-wrapper'));
}

function updateBtnPrice(ele){
  const parent_ele = ele.closest('.productinfo-wrapper');  
  if( parent_ele == null ) return;
  const qty_box_ele = parent_ele.querySelector('.quantity-box');
  let add_to_total = 0;
  qty_box_ele.querySelectorAll('quantity-input').forEach((qty_ele)=>{
    let q_value = Number(qty_ele.querySelector('input').value);
    const q_price = Number(qty_ele.closest('.purchase-card').querySelector('.price').dataset.price);
    if( qty_ele.querySelector('input').min != null ){
      let min_value = Number(qty_ele.querySelector('input').min);
      q_value = q_value < min_value ? min_value: q_value;
    }
    add_to_total = add_to_total + ( q_value * q_price );
  })
  if( add_to_total > 0 ){
    parent_ele.querySelector('.product-form__submit .price').innerHTML = formatMoney(add_to_total);
  }
}
  
/* Length Function END */

window.addEventListener('load', function(event){
});

document.addEventListener("DOMContentLoaded", (event) => {
  var windowWidth = window.innerWidth;

  /* Media filter */
  document.querySelectorAll('[data-media-nav] a').forEach(function (element) {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      let data_type = element.dataset.type;
      let ele = document.querySelector('.product__media-list .product__media-item[data-media-type='+ data_type +']');
      let ele_index = Number(ele.getAttribute('aria-label').split(' /')[0]) - 1;
      
      document.querySelector('.product__media-sublist.swiper-initialized') && document.querySelector('.product__media-sublist.swiper-initialized').swiper.slideTo(ele_index);
      document.querySelector('.product__media-list.swiper-initialized') && document.querySelector('.product__media-list.swiper-initialized').swiper.slideTo(ele_index);

      document.querySelectorAll('[data-media-nav] a.active').forEach(function (active_ele) {
        active_ele.classList.remove('active');
      });
      element.classList.add('active');
      
      /*document.querySelectorAll('.product__media-list .product__media-item:not([data-media-type='+ data_type +']), .product__media-sublist .product__media-subitem:not([data-media-type='+ data_type +'])').forEach(function (imgEle) {
        imgEle.classList.remove('swiper-slide');
        imgEle.classList.add("non-swiper-slide");
        imgEle.classList.add("hidden");
      });
      document.querySelectorAll('.product__media-list .product__media-item[data-media-type='+ data_type +'], .product__media-sublist .product__media-subitem[data-media-type='+ data_type +']').forEach(function (imgEle) {
        imgEle.classList.add('swiper-slide');
        imgEle.classList.remove("non-swiper-slide");
        imgEle.classList.remove("hidden");
      });
      document.querySelector('.product__media-sublist.swiper-initialized') && document.querySelector('.product__media-sublist.swiper-initialized').swiper.update();
      document.querySelector('.product__media-list.swiper-initialized') && document.querySelector('.product__media-list.swiper-initialized').swiper.update();*/
    });    
  });  

  if( document.querySelector('.product-gallery--with-thumbnails .media-highlights-wrap > div a.active') ){
    document.querySelector('.product-gallery--with-thumbnails .media-highlights-wrap > div a.active').click();
  }
  /* Media fliter */

  /* Product media text banner */
  $(".productT_offer--iteam span").length > 1 && ($(".productT_offer--iteam:not(.slick-initialized)").slick({
    infinite: !0,
    slidesToShow: 1,
    adaptiveHeight: !0,
    slidesToScroll: 1
  }));
  /* Product media text banner */

  $(document).on('click', function (e) {
    const ele_target = $(e.target);
    if ($(e.target).is('.zoom-anim-dialog') === true || $(e.target).is('.mfp-container') === true) {
      $.magnificPopup.close();
      $('body, html').removeClass("price-match-popup-open");
    }

    if( $(ele_target).hasClass('tab--title') == false && $('.tab-content.active').length > 0 && $('.tab-content.active .content--part').css('display') != 'none' ){        
      if( (ele_target.hasClass('active') || ele_target.closest('.tab-content.active')) && ele_target.closest('.content--part').length == 0 ){          
        $('.tab-content.active').toggleClass('active')
      }
    }      
  });

  /* Product tabs */
    document.querySelectorAll('.product--tabs--new ul.tabs li').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');
        
        document.querySelectorAll('.product--tabs--new ul.tabs li.current').forEach(function(tab) {
          tab.classList.remove('current');
        });
        
        this.classList.add('current');
        
        var targetElement = document.getElementById(tabId);
        if (targetElement) {
          $('html, body').animate({
            scrollTop: $(targetElement).offset().top - 150
          }, 900);
          // window.scrollTo({
          //   top: targetElement.offsetTop - 150,
          //   behavior: 'smooth'
          // });
        }
      });
    });
    
    $(document).on('click','.product--tabs--new .tab--title', function(e){
      e.preventDefault();
      $(this).parent().toggleClass('active');
      if( $(this).closest('.tab-content').find('.content--part').length ){
        //$(this).closest('.tab-content').find('.content--part').slideToggle();
      }      
      if( $(this).closest('.tab-content').find('.accordion').length ){
        //$(this).closest('.tab-content').find('.accordion').slideToggle();
      }
    });

    document.querySelectorAll('.content--part .header svg').forEach((SVGElement)=>{
      SVGElement.addEventListener('click', (event)=>{
        //$(SVGElement.closest('.content--part')).slideToggle();
        $(SVGElement.closest('.tab-content')).toggleClass('active');
      });
    });
  
    $(document).on('click','.product--tabs--new .inner-title-wrap', function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).closest('.spec-block').find('.table--wraper').slideToggle(400);
    });
    
  /* Product tabs */

  /* Swiper JS recommand */

  if(document.querySelectorAll('.recommended-prod-lists .recommended-prod').length > 3){
    const swiper = new Swiper('.recommended-prod-lists', {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.recommended-product .swiper-btn-next',
        prevEl: '.recommended-product .swiper-btn-prev',
      }
    });
  }
});


$(document).on('click','.block-swatch .product_tags, .color-swatch-list .color-swatch span',function(){
  var url = $(this).data('url');
  window.location = url;
});

$(document).on('click','.pro-variant_wrapper .color-swatch span',function(){
  var id = $(this).data('id');
  $('.variant_list .color-swatch').each(function(){
    if($(this).find('span').hasClass('active')){
      $(this).find('span').removeClass('active');
    }
  });
  $(this).addClass('active');
  $(this).closest('.pro-content').find('.btn-wrapper span').attr('data-id',id);  
});

document.addEventListener("click", (t) => {
  let target = $(t.target);

  ($(target).closest("body").find(".variant-dropdown .variant-swatch-dp.active").length || 
  $(target).closest(".product_tags.active").length) && 
  !1 === $(target).is(".variant-dropdown .variant-swatch--options") && $(".variant-dropdown .variant-swatch-dp").removeClass("active");
  
  if( target.closest('[data-color-swatches]').length > 0 || target.data('color-swatches') != null ){    
  } else if ($('.color--swatch--title.active').length ){    
    (target.closest('.color_swatch_listing').length == 0 || target.closest('.block-swatch-list').length == 0) && 
    $('.color--swatch--title.active').removeClass('active');
  }
});

document.querySelectorAll('.floor-model-wrapper .checkboxs label input').forEach(input => {
  input.addEventListener('change', function() {
    if( input.checked ){
      document.querySelector('.floor-model-wrapper .erro-msg').classList.add('hide');      
    }else{
      document.querySelector('.floor-model-wrapper .erro-msg').classList.remove('hide');
    }
  });
});

function closePopup() {
  $.magnificPopup.close();
}

function clickEventDropDown(event, ele){
  event.preventDefault();
  let _this = ele;
  document.querySelectorAll('.product__info-container [data-color-swatches].active').forEach((l_ele) =>{
    _this != l_ele && l_ele.classList.remove('active');
  });
  if( !_this.classList.contains('active') ){
    _this.classList.add('active');
  }else{
    _this.classList.remove('active');
  }  
}

/**accordion-section**/
const clickedAccordian = function(accord_ele, event) {
  event.preventDefault();
  var eleParent = $(accord_ele).parent();
  if ($(eleParent).hasClass('active')) {
    $(accord_ele).next().slideUp(function() {
      $(eleParent).removeClass('active');
    });
  } else {
    $(eleParent).closest('.accordion').find('.active').each(function(i, ele) {
      $(ele).find('.accordion-content').slideUp(function() {
        $(ele).removeClass('active');
      });
    }).removeClass('active');
    $(accord_ele).next().slideDown({
      start: function() {
        $(this).css({
          display: "flex"
        })
      },
      complete: function() {
        $(eleParent).addClass('active');
      }
    });
  }
};
/**accordion-section**/
/* ---------------------------------------------------------------------------
   Deep-link purchase option
   /products/<handle>?variant=<id> selects that option on load.
   Runs through the theme's own change pipeline, so price, SKU, media,
   quantity box and Add to Cart all update exactly as if it were clicked.
   A page opened without ?variant= keeps the "Please select" default.
--------------------------------------------------------------------------- */
(function () {
  function preselectVariantFromUrl() {
    var variantId;
    try {
      variantId = new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      return;
    }
    if (!variantId) return;

    document.querySelectorAll('variant-selects').forEach(function (selects) {
      if (selects.closest('quick-add-modal')) return;

      var json = selects.querySelector('script[type="application/json"]');
      if (!json) return;

      var variants;
      try {
        variants = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants)) return;

      var variant = variants.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      if (!variant || variant.available === false) return;

      var firstInput = null;

      selects.querySelectorAll('fieldset[data-index]').forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-index'), 10);
        if (isNaN(index)) return;

        var value = variant['option' + (index + 1)];
        if (!value) return;

        var input = Array.prototype.filter.call(
          fieldset.querySelectorAll('input[type="radio"]'),
          function (radio) {
            return radio.value === value;
          }
        )[0];
        if (!input || input.classList.contains('disabled')) return;

        var row = input.closest('.pricing-option') || input.closest('.items');
        if (row && row.classList.contains('hide-sold_out')) return;

        input.checked = true;
        if (!firstInput) firstInput = input;
      });

      if (firstInput) {
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* The variant change handler calls updateMedia(), which needs the gallery
     swiper. Wait for it, or the handler throws on .swiper.slideTo and the
     price / SKU / Add to Cart update never happens. */
  function whenGalleryReady() {
    return new Promise(function (resolve) {
      var waited = 0;
      (function check() {
        var lists = document.querySelectorAll('.product__media-wrapper .js-media-list');
        var ready = true;
        lists.forEach(function (list) {
          if (!list.swiper) ready = false;
        });
        if (ready || waited >= 8000) return resolve();
        waited += 100;
        setTimeout(check, 100);
      })();
    });
  }

  /* <variant-selects> is upgraded by global.js, which can run after this file,
     so wait for the element to be defined before dispatching the change. */
  function start() {
    var defined =
      window.customElements && customElements.whenDefined
        ? customElements.whenDefined('variant-selects')
        : Promise.resolve();
    defined
      .catch(function () {})
      .then(whenGalleryReady)
      .then(preselectVariantFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
